import React from 'react'
import reactDom from 'react-dom'
// GraphQL
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { split } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
// Store
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import reducer from './reducers'
import initialState from './state'
// Components
import Start from './Start'
// Solves 300ms click lag on Cordova, while not affecting web app.
import injectTapEventPlugin from 'react-tap-event-plugin'
injectTapEventPlugin()

// GraphQL
const httpLink = new HttpLink({ uri: 'https://api.graph.cool/simple/v1/cjbv8phe31ewz0117bwr7yk6z' })
const wsLink = new WebSocketLink({
	uri: 'wss://subscriptions.us-west-2.graph.cool/v1/cjbv8phe31ewz0117bwr7yk6z',
	options: { reconnect: true }
})
const link = split(
	({ query }) => {
		const { kind, operation } = getMainDefinition(query)
		return kind === 'OperationDefinition' && operation === 'subscription'
	},
	wsLink,
	httpLink
)
const middlewareLink = new ApolloLink((operation, forward) => {
	const token = window.localStorage.getItem('MoonSignApp:login')
	const authorizationHeader = token ? `Bearer ${token}` : null
	operation.setContext({ headers: { authorization: authorizationHeader } })
	return forward(operation)
})
const httpLinkWithAuthToken = middlewareLink.concat(link)
const client = new ApolloClient({
	link: httpLinkWithAuthToken,
	// eslint-disable-next-line
	cache: new InMemoryCache().restore(window.__APOLLO_STATE__)
})

// Logger
const logger = createLogger({
	level: {
		prevState: () => `info`,
		error: () => `error`,
		nextState: () => `info`
	},
	collapsed: true,
	duration: false,
	actionTransformer: (action) => ({ ...action, type: String(action.type) }),
	colors: {
		prevState: () => `#FF0000`,
		nextState: () => `#4CAF50`
	},
	diff: false
})

// Store
const store = process.env.NODE_ENV === 'development'
	? createStore(reducer, initialState, applyMiddleware(thunk, logger))
	: createStore(reducer, initialState, applyMiddleware(thunk))

// App
const App = () => {
	reactDom.render((
		<ApolloProvider client={client}>
			<Start store={store} />
		</ApolloProvider>
	), document.querySelector('MoonSignApp'))
}

store.subscribe(App)
store.dispatch({ type: 'SET_PAGE', page: '' })
console.log('Welcome to the Moon Sign App!')



// WEBPACK FOOTER //
// ./src/index.js